import { render } from "./FormItem.vue?vue&type=template&id=8947c486&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"

import "./FormItem.vue?vue&type=style&index=0&id=8947c486&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8947c486"]])

export default __exports__